import script from "./KCircleIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./KCircleIcon.vue?vue&type=script&setup=true&lang=ts"

import "./KCircleIcon.vue?vue&type=style&index=0&id=179b2616&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-179b2616"]])

export default __exports__